var map = {
	"./afb-color.svg": 645,
	"./alb-color.svg": 646,
	"./all.svg": 647,
	"./amb-color.svg": 648,
	"./arg.svg": 649,
	"./aus.svg": 650,
	"./bank-icon.svg": 651,
	"./bankdemo-color.svg": 652,
	"./bel.svg": 653,
	"./bimb-color.svg": 654,
	"./bkr-color.svg": 655,
	"./bpay-color.svg": 656,
	"./bra.svg": 657,
	"./bsn-color.svg": 658,
	"./can.svg": 659,
	"./checked-white.png": 660,
	"./cimb-color.svg": 661,
	"./cimb-icon.svg": 662,
	"./citi-color.svg": 663,
	"./cmr.svg": 664,
	"./crc.svg": 665,
	"./cro.svg": 666,
	"./den.svg": 667,
	"./ecu.svg": 668,
	"./eng.svg": 669,
	"./esp.svg": 670,
	"./esports-active-m.svg": 671,
	"./esports-m.svg": 672,
	"./fav-gray.png": 673,
	"./fav-icon-active.png": 674,
	"./fav-icon.png": 675,
	"./fav-red.png": 676,
	"./fra.svg": 677,
	"./game-icon.svg": 678,
	"./games-active-m.svg": 679,
	"./games-m.svg": 680,
	"./ger.svg": 681,
	"./gha.svg": 682,
	"./gxbank-color.svg": 683,
	"./hlb-color.svg": 684,
	"./hlb-icon.svg": 685,
	"./hsbc-color.svg": 686,
	"./irn.svg": 687,
	"./jpn.svg": 688,
	"./kor.svg": 689,
	"./ksa.svg": 690,
	"./kwh-color.svg": 691,
	"./latest-icon-active.png": 692,
	"./latest-icon.png": 693,
	"./lc-active-m.svg": 694,
	"./lc-icon.svg": 695,
	"./lc-m.svg": 696,
	"./lottery-active-m.svg": 697,
	"./lottery-icon.svg": 698,
	"./lottery-m.svg": 699,
	"./love.svg": 700,
	"./mar.svg": 701,
	"./mbb-color.svg": 702,
	"./mex.svg": 703,
	"./ned.svg": 704,
	"./ocbc-color.svg": 705,
	"./ocbc-icon.svg": 706,
	"./p2p-active-m.svg": 707,
	"./p2p-icon.svg": 708,
	"./p2p-m.svg": 709,
	"./pbb-color.svg": 710,
	"./pol.svg": 711,
	"./por.svg": 712,
	"./price-high.svg": 713,
	"./price-low.svg": 714,
	"./qat.svg": 715,
	"./rhb-color.svg": 716,
	"./rhb-icon.svg": 717,
	"./scb-color.svg": 718,
	"./sen.svg": 719,
	"./slot-active-m.svg": 720,
	"./slot-icon.svg": 721,
	"./slot-m.svg": 722,
	"./speed-active-m.svg": 723,
	"./speed-m.svg": 724,
	"./sport-active-m.svg": 725,
	"./sport-m.svg": 726,
	"./sports-icon.svg": 727,
	"./square-icon.svg": 728,
	"./srb.svg": 729,
	"./star.svg": 730,
	"./sui.svg": 731,
	"./tng-color.svg": 732,
	"./trx-icon.svg": 733,
	"./trx.svg": 734,
	"./tun.svg": 735,
	"./uefa-icon.svg": 736,
	"./uob-color.svg": 737,
	"./uru.svg": 738,
	"./usa.svg": 739,
	"./usdc.svg": 740,
	"./usdt.svg": 741,
	"./ustd-icon.svg": 742,
	"./wal.svg": 743,
	"./x33-logo-b.svg": 744,
	"./x33-square-icon.svg": 745
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1672;